<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Portaria
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <div style="margin-top: 10px;">
        <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
          style="display:none;">
        <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
          style='background-color: whitesmoke;'>
          <mat-icon class='icon-add'>image_search</mat-icon>
          Selecionar arquivo
        </a>
      </div>

      <div style="margin: 20px 10px 10px 10px;">
        <span *ngIf="!selectedFileName">Nenhum arquivo selecionado</span>
        <span *ngIf="selectedFileName && !storedFile">{{selectedFileName}}</span>
        <a *ngIf="selectedFileName && storedFile" target="_blank" [href]="storedFile"
          style='background-color: whitesmoke;'>
          {{selectedFileName}}
        </a>
      </div>

      <mat-form-field appearance="outline" style="margin-top: 10px;">
        <mat-label>Tipo</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.type">
          <mat-option *ngFor="let type of types" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="entityForm.controls.type.hasError('required')">
          Selecione uma tipo
        </mat-error>
      </mat-form-field>

      <mat-form-field style='width: 190px; margin-left: 20px;' appearance="outline">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field style='width: 180px; margin-left: 20px;' appearance="outline">
        <mat-label>Número</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.number"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Título</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Assunto</mat-label>
        <textarea style="height: 110px;" matInput [errorStateMatcher]="matcher"
          [formControl]="entityForm.controls.subject" autocomplete="off">
              </textarea>
      </mat-form-field>

      <mat-form-field style='width: 620px;' appearance="outline">
        <mat-label>Link</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.link"
          autocomplete="off">
      </mat-form-field>

      <mat-checkbox color='primary' [formControl]="entityForm.controls.publish">
        Publicar
      </mat-checkbox>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>